module.exports = __webpack_public_path__ + "static/media/ic_popup_premium_onboarding_big.e1f2ca90.svg";